import { NgModule } from '@angular/core';
import { APOLLO_NAMED_OPTIONS, NamedOptions } from 'apollo-angular';

import {
	CloudDeviceApiService,
	CloudGatewayApiService,
	DEVICE_DISCOVERY_CLAIMING_SERVICE,
	DetectionTokenApiService,
	DeviceClaimingApiService,
	DeviceClaimingDiscoveryApiService,
	DeviceDiscoveryApiService,
	DevicePropertyPanelApiService,
	DeviceStatusService,
	DeviceTagsApiService,
	InventoryDevicesApiService,
	SystemStatusApiService
} from '../api';
import { ScheduledJobsApiService } from '../api/scheduled-jobs-api.service';

import { SysApiCloudDeviceApiService } from './sys-api-cloud-device-api.service';
import { SysApiCloudGatewayApiService } from './sys-api-cloud-gateway-api.service';
import { SysApiConnectionService } from './sys-api-connection.service';
import { SysApiDetectionTokenApiService } from './sys-api-detection-token-api.service';
import { SysApiDeviceClaimingApiService } from './sys-api-device-claiming-api.service';
import { SysApiDeviceClaimingDiscoveryApiService } from './sys-api-device-claiming-discovery-api.service';
import { SysApiDeviceDiscoveryApiService } from './sys-api-device-discovery-api.service';
import { SysApiDeviceInventoryApolloCache } from './sys-api-device-inventory-apollo-cache.service';
import { SysApiDevicePropertyPanelApiService } from './sys-api-device-property-panel-api.service';
import { SysApiDeviceTagApiService } from './sys-api-device-tag-api.service';
import { SysApiInventoryDevicesApiService } from './sys-api-inventory-devices-api.service';
import { SysApiScheduledJobsApiService } from './sys-api-scheduled-jobs-api.service';
import { SysApiSystemStatusApiService } from './sys-api-system-status-api.service';

@NgModule({
	providers: [
		DeviceStatusService,
		{
			provide: CloudDeviceApiService,
			useClass: SysApiCloudDeviceApiService
		},
		{
			provide: DetectionTokenApiService,
			useClass: SysApiDetectionTokenApiService
		},
		{
			provide: DeviceClaimingApiService,
			useClass: SysApiDeviceClaimingApiService
		},
		{
			provide: DeviceClaimingDiscoveryApiService,
			useClass: SysApiDeviceClaimingDiscoveryApiService
		},
		{
			provide: DeviceDiscoveryApiService,
			useClass: SysApiDeviceDiscoveryApiService
		},
		{
			provide: InventoryDevicesApiService,
			useClass: SysApiInventoryDevicesApiService
		},
		{
			provide: DevicePropertyPanelApiService,
			useClass: SysApiDevicePropertyPanelApiService
		},
		{
			provide: DEVICE_DISCOVERY_CLAIMING_SERVICE,
			useClass: SysApiDeviceClaimingDiscoveryApiService
		},
		{
			provide: DeviceTagsApiService,
			useClass: SysApiDeviceTagApiService
		},
		{
			provide: CloudGatewayApiService,
			useClass: SysApiCloudGatewayApiService
		},
		{
			provide: SystemStatusApiService,
			useClass: SysApiSystemStatusApiService
		},
		{
			provide: ScheduledJobsApiService,
			useClass: SysApiScheduledJobsApiService
		},
		SysApiConnectionService,
		SysApiDeviceInventoryApolloCache,
		{
			provide: APOLLO_NAMED_OPTIONS,
			useFactory(sysApiConnectionService: SysApiConnectionService): NamedOptions {
				const options: NamedOptions = {
					sysApi: sysApiConnectionService.createApolloClientOptions()
				};
				return options;
			},
			deps: [SysApiConnectionService]
		}
	]
})
export class SysApiDevicesDataAccessModule {}
